// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import DatePickerPresentationPropsDefault from "@insite/mobius/DatePicker/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import { xBaseTheme } from "@monsma/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        ...DatePickerPresentationPropsDefault,
        cssOverrides: {
            datePicker: css`
                &&& .react-calendar__tile {
                    &--now {
                        color: ${getColor("primary")};
                    }

                    &--hasActive:not(:disabled):not(.react-calendar__month-view__days__day--neighboringMonth),
                    &--active:not(:disabled):not(.react-calendar__month-view__days__day--neighboringMonth) {
                        color: ${({ theme }) => getContrastColor("primary", theme)};
                    }
                }
            `,
        },
    },
} as xBaseTheme["datePicker"];
